import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/api/errors';

/** Do not retry a request the server understood and refused (4xx); retry network and 5xx twice. */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

/**
 * TanStack Query is the only server-state layer. Defaults are deliberately plain: a short stale time,
 * refetch when the tab regains focus (a guest returning to the app sees a waiter's changes), and no
 * automatic retry of mutations (a repeated mutation needs its own idempotency decision).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        retry: shouldRetryQuery,
        refetchOnWindowFocus: true,
      },
      mutations: { retry: false },
    },
  });
}
